import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import BottomTabs from "./BottomTabs";
import { useIsMobile } from "@/hooks/use-mobile";
import { usePlatform } from "@/hooks/use-platform";
import { useMobileKeyboardOpen } from "@/hooks/use-mobile-keyboard-open";
import { useSidebarContext } from "@/context/SidebarContext";
import { cn } from "@/lib/utils";

const Layout = () => {
  const isMobile = useIsMobile();
  const platform = usePlatform();
  const isIOS = platform === 'ios';
  const isKeyboardOpen = useMobileKeyboardOpen();
  const { isCollapsed } = useSidebarContext();
  const showBottomTabs = (isMobile || isIOS) && !isKeyboardOpen;

  return (
    <div 
      className={cn(
        "bg-background",
        isMobile || isIOS ? "h-screen overflow-hidden" : "min-h-screen"
      )}
    >
      {/* Show navbar only for desktop. Mobile and iOS use bottom tabs */}
      {!isMobile && !isIOS && <Navbar />}
      
      <main 
        className={cn(
          isMobile || isIOS
            ? "h-full overflow-hidden px-4"
            : cn(
                "transition-all duration-300",
                `${isCollapsed ? 'ml-16' : 'ml-64'} py-6 px-8`
              )
        )}
        style={{
          paddingTop: isIOS ? 'env(safe-area-inset-top)' : undefined,
          paddingBottom: isMobile || isIOS
            ? (showBottomTabs ? 'calc(60px + env(safe-area-inset-bottom))' : 'env(safe-area-inset-bottom)')
            : undefined
        }}
      >
        <div className={cn(
          isMobile || isIOS ? "h-full overflow-hidden mx-auto" : "max-w-6xl mx-auto"
        )}>
          <Outlet />
        </div>
      </main>

      {/* Show bottom tabs for mobile web and iOS native */}
      {showBottomTabs && <BottomTabs />}
    </div>
  );
};

export default Layout;
